const hosts=[
    {
        "hostid": "10084",
        "host": "Zabbix server",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "4",
            "name": "Zabbix servers",
            "internal": "0",
            "flags": "0",
            "uuid": "6f6799aa69e844b4b3918f779f2abf08"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "108",
            "name": "C5I",
            "internal": "0",
            "flags": "0",
            "uuid": "bfcc57049e844ec383b6b6868bce0d19"
          }
        ],
        "tags": [],
        "inventory": [],
        "interfaces": [
          {
            "interfaceid": "1",
            "hostid": "10084",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "127.0.0.1",
            "dns": "",
            "port": "10050",
            "available": "1",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10596",
        "host": "ABAS-C4-TELEFONIA-SYNWAY-SMG1004C-40-MEDIA-GATEWAY-SYNWAY01-GTO-SUB-ABAS-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "54",
            "name": "ABASOLO",
            "internal": "0",
            "flags": "0",
            "uuid": "aa9a1fde3b2f45dabbfdee5d9f8e7326"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Jardín Hidalgo #101, Zona Centro, Presidencia Municipal, 36970, Abasolo, Gto.",
          "location_lat": "20.4510404",
          "location_lon": "-101.528446"
        },
        "interfaces": [
          {
            "interfaceid": "118",
            "hostid": "10596",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.201.101",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10597",
        "host": "ABAS-C4-TELEFONIA-SYNWAY-SMG1004C-40-MEDIA-GATEWAY-SYNWAY02-GTO-SUB-ABAS-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "54",
            "name": "ABASOLO",
            "internal": "0",
            "flags": "0",
            "uuid": "aa9a1fde3b2f45dabbfdee5d9f8e7326"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Jardín Hidalgo #101, Zona Centro, Presidencia Municipal, 36970, Abasolo, Gto.",
          "location_lat": "20.4510404",
          "location_lon": "-101.528446"
        },
        "interfaces": [
          {
            "interfaceid": "119",
            "hostid": "10597",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.201.102",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10598",
        "host": "ABAS-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT -18330-GTO-SUB-ABAS-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "54",
            "name": "ABASOLO",
            "internal": "0",
            "flags": "0",
            "uuid": "aa9a1fde3b2f45dabbfdee5d9f8e7326"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Jardín Hidalgo #101, Zona Centro, Presidencia Municipal, 36970, Abasolo, Gto.",
          "location_lat": "20.4510404",
          "location_lon": "-101.528446"
        },
        "interfaces": [
          {
            "interfaceid": "120",
            "hostid": "10598",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.201.80",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10599",
        "host": "ABAS-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT -18331-GTO-SUB-ABAS-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "54",
            "name": "ABASOLO",
            "internal": "0",
            "flags": "0",
            "uuid": "aa9a1fde3b2f45dabbfdee5d9f8e7326"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Jardín Hidalgo #101, Zona Centro, Presidencia Municipal, 36970, Abasolo, Gto.",
          "location_lat": "20.4510404",
          "location_lon": "-101.528446"
        },
        "interfaces": [
          {
            "interfaceid": "121",
            "hostid": "10599",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.201.81",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10600",
        "host": "ABAS-C4-TELEFONIA-BUFFALO-LS520D-NAS-NAS-GTO-SUB-ABAS-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "46",
            "name": "TELEFONIA/NAS",
            "internal": "0",
            "flags": "0",
            "uuid": "d784be157c1947eeba80d151c15a6273"
          },
          {
            "groupid": "54",
            "name": "ABASOLO",
            "internal": "0",
            "flags": "0",
            "uuid": "aa9a1fde3b2f45dabbfdee5d9f8e7326"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Jardín Hidalgo #101, Zona Centro, Presidencia Municipal, 36970, Abasolo, Gto.",
          "location_lat": "20.4510404",
          "location_lon": "-101.528446"
        },
        "interfaces": [
          {
            "interfaceid": "122",
            "hostid": "10600",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.201.108",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10601",
        "host": "ABAS-C4-TELEFONIA-ISSABEL-NLXMU-PBX-ISB-HA-GTO-SUB-ABAS-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "47",
            "name": "TELEFONIA/PBX/FLOTANTE",
            "internal": "0",
            "flags": "0",
            "uuid": "0c74af60060f4249b4da486409ca44ab"
          },
          {
            "groupid": "54",
            "name": "ABASOLO",
            "internal": "0",
            "flags": "0",
            "uuid": "aa9a1fde3b2f45dabbfdee5d9f8e7326"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Jardín Hidalgo #101, Zona Centro, Presidencia Municipal, 36970, Abasolo, Gto.",
          "location_lat": "20.4510404",
          "location_lon": "-101.528446"
        },
        "interfaces": [
          {
            "interfaceid": "123",
            "hostid": "10601",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.201.105",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10602",
        "host": "ACAM-C4-TELEFONIA-SYNWAY-SMG1004C-40-MEDIA-GATEWAY-SYNWAY01-GTO-SUB-ACAM-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "63",
            "name": "ACAMBARO",
            "internal": "0",
            "flags": "0",
            "uuid": "fe29e1fe5f0a4a03867ea2e5ae691f9e"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Rio Colorado #29, Col. Los Sauces, 38674, ACAMBARO, Gto.",
          "location_lat": "20.0095358",
          "location_lon": "-100.72339"
        },
        "interfaces": [
          {
            "interfaceid": "124",
            "hostid": "10602",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.202.101",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10603",
        "host": "ACAM-C4-TELEFONIA-SYNWAY-SMG1004C-40-MEDIA-GATEWAY-SYNWAY02-GTO-SUB-ACAM-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "63",
            "name": "ACAMBARO",
            "internal": "0",
            "flags": "0",
            "uuid": "fe29e1fe5f0a4a03867ea2e5ae691f9e"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Rio Colorado #29, Col. Los Sauces, 38674, ACAMBARO, Gto.",
          "location_lat": "20.0095358",
          "location_lon": "-100.72339"
        },
        "interfaces": [
          {
            "interfaceid": "125",
            "hostid": "10603",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.202.102",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10604",
        "host": "ACAM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18340-GTO-SUB-ACAM-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "63",
            "name": "ACAMBARO",
            "internal": "0",
            "flags": "0",
            "uuid": "fe29e1fe5f0a4a03867ea2e5ae691f9e"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Rio Colorado #29, Col. Los Sauces, 38674, ACAMBARO, Gto.",
          "location_lat": "20.0095358",
          "location_lon": "-100.72339"
        },
        "interfaces": [
          {
            "interfaceid": "126",
            "hostid": "10604",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.202.80",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10605",
        "host": "ACAM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18341-GTO-SUB-ACAM-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "63",
            "name": "ACAMBARO",
            "internal": "0",
            "flags": "0",
            "uuid": "fe29e1fe5f0a4a03867ea2e5ae691f9e"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Rio Colorado #29, Col. Los Sauces, 38674, ACAMBARO, Gto.",
          "location_lat": "20.0095358",
          "location_lon": "-100.72339"
        },
        "interfaces": [
          {
            "interfaceid": "127",
            "hostid": "10605",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.202.81",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10606",
        "host": "ACAM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18342-GTO-SUB-ACAM-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "63",
            "name": "ACAMBARO",
            "internal": "0",
            "flags": "0",
            "uuid": "fe29e1fe5f0a4a03867ea2e5ae691f9e"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Rio Colorado #29, Col. Los Sauces, 38674, ACAMBARO, Gto.",
          "location_lat": "20.0095358",
          "location_lon": "-100.72339"
        },
        "interfaces": [
          {
            "interfaceid": "128",
            "hostid": "10606",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.202.83",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10607",
        "host": "ACAM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18343-GTO-SUB-ACAM-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "63",
            "name": "ACAMBARO",
            "internal": "0",
            "flags": "0",
            "uuid": "fe29e1fe5f0a4a03867ea2e5ae691f9e"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Rio Colorado #29, Col. Los Sauces, 38674, ACAMBARO, Gto.",
          "location_lat": "20.0095358",
          "location_lon": "-100.72339"
        },
        "interfaces": [
          {
            "interfaceid": "129",
            "hostid": "10607",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.202.82",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10609",
        "host": "ACAM-C4-TELEFONIA-BUFFALO-LS220D-NAS-NAS-GTO-SUB-ACAM-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "46",
            "name": "TELEFONIA/NAS",
            "internal": "0",
            "flags": "0",
            "uuid": "d784be157c1947eeba80d151c15a6273"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "63",
            "name": "ACAMBARO",
            "internal": "0",
            "flags": "0",
            "uuid": "fe29e1fe5f0a4a03867ea2e5ae691f9e"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Rio Colorado #29, Col. Los Sauces, 38674, ACAMBARO, Gto.",
          "location_lat": "20.0095358",
          "location_lon": "-100.72339"
        },
        "interfaces": [
          {
            "interfaceid": "131",
            "hostid": "10609",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.202.108",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10610",
        "host": "ACAM-C4-TELEFONIA-ISSABEL-ISS-UCR-ENTRY-PBX-ISB-HA-GTO-SUB-ACAM-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "47",
            "name": "TELEFONIA/PBX/FLOTANTE",
            "internal": "0",
            "flags": "0",
            "uuid": "0c74af60060f4249b4da486409ca44ab"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "63",
            "name": "ACAMBARO",
            "internal": "0",
            "flags": "0",
            "uuid": "fe29e1fe5f0a4a03867ea2e5ae691f9e"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Rio Colorado #29, Col. Los Sauces, 38674, ACAMBARO, Gto.",
          "location_lat": "20.0095358",
          "location_lon": "-100.72339"
        },
        "interfaces": [
          {
            "interfaceid": "132",
            "hostid": "10610",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.202.105",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10611",
        "host": "SANM-C4-TELEFONIA-SYNWAY-SMG1004C-40-MEDIA-GATEWAY-SYNWAY01-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "133",
            "hostid": "10611",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.233.101",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10612",
        "host": "SANM-C4-TELEFONIA-SYNWAY-SMG1004C-40-MEDIA-GATEWAY-SYNWAY02-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "134",
            "hostid": "10612",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.233.102",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10613",
        "host": "SANM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18301-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "135",
            "hostid": "10613",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.133.101",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10614",
        "host": "SANM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18302-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "136",
            "hostid": "10614",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.133.102",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10615",
        "host": "SANM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18303-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "137",
            "hostid": "10615",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.133.103",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10616",
        "host": "SANM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18311-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "138",
            "hostid": "10616",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.133.104",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10617",
        "host": "SANM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18312-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "139",
            "hostid": "10617",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.133.105",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10618",
        "host": "SANM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18313-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "140",
            "hostid": "10618",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.133.106",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10619",
        "host": "SANM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18314-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "141",
            "hostid": "10619",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.133.107",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10620",
        "host": "SANM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18315-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "142",
            "hostid": "10620",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.133.108",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10621",
        "host": "SANM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18316-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "143",
            "hostid": "10621",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.133.109",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10622",
        "host": "SANM-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18317-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "144",
            "hostid": "10622",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.133.110",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10623",
        "host": "SANM-C4-TELEFONIA-BUFFALO-LS520DN0402-NAS-NAS-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "46",
            "name": "TELEFONIA/NAS",
            "internal": "0",
            "flags": "0",
            "uuid": "d784be157c1947eeba80d151c15a6273"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "145",
            "hostid": "10623",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.233.108",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10624",
        "host": "SANM-C4-TELEFONIA-ISSABEL-ISS-UCR-ENTRY-PBX-ISB-HA-GTO-SUB-SMAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "47",
            "name": "TELEFONIA/PBX/FLOTANTE",
            "internal": "0",
            "flags": "0",
            "uuid": "0c74af60060f4249b4da486409ca44ab"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "65",
            "name": "SAN MIGUEL DE ALLENDE",
            "internal": "0",
            "flags": "0",
            "uuid": "6dc8b53d58d04f218bffe0629fb1005c"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Edificio Presidencia, México 111, San Miguel, Gto.",
          "location_lat": "20.9039631",
          "location_lon": "-100.713282"
        },
        "interfaces": [
          {
            "interfaceid": "146",
            "hostid": "10624",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.233.105",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10625",
        "host": "APASA-C4-TELEFONIA-SYNWAY-SMG1004C-40-MEDIA-GATEWAY-SYNWAY01-GTO-SUB-APAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "64",
            "name": "APASEO EL ALTO",
            "internal": "0",
            "flags": "0",
            "uuid": "149aa153e4624ac1b11d01264d26d89f"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Estatal Apaseo el Alto-Tarimoro s/n, Entronque La Luisiada, Apaseo el Alto, Gto.",
          "location_lat": "20.4573188",
          "location_lon": "-100.623978"
        },
        "interfaces": [
          {
            "interfaceid": "147",
            "hostid": "10625",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.203.101",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10626",
        "host": "APASA-C4-TELEFONIA-SYNWAY-SMG1004C-40-MEDIA-GATEWAY-SYNWAY02-GTO-SUB-APAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "64",
            "name": "APASEO EL ALTO",
            "internal": "0",
            "flags": "0",
            "uuid": "149aa153e4624ac1b11d01264d26d89f"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Estatal Apaseo el Alto-Tarimoro s/n, Entronque La Luisiada, Apaseo el Alto, Gto.",
          "location_lat": "20.4573188",
          "location_lon": "-100.623978"
        },
        "interfaces": [
          {
            "interfaceid": "148",
            "hostid": "10626",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.203.102",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10627",
        "host": "APASA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18350-GTO-SUB-APAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "64",
            "name": "APASEO EL ALTO",
            "internal": "0",
            "flags": "0",
            "uuid": "149aa153e4624ac1b11d01264d26d89f"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Estatal Apaseo el Alto-Tarimoro s/n, Entronque La Luisiada, Apaseo el Alto, Gto.",
          "location_lat": "20.4573188",
          "location_lon": "-100.623978"
        },
        "interfaces": [
          {
            "interfaceid": "149",
            "hostid": "10627",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.203.80",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10628",
        "host": "APASA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18351-GTO-SUB-APAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "64",
            "name": "APASEO EL ALTO",
            "internal": "0",
            "flags": "0",
            "uuid": "149aa153e4624ac1b11d01264d26d89f"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Estatal Apaseo el Alto-Tarimoro s/n, Entronque La Luisiada, Apaseo el Alto, Gto.",
          "location_lat": "20.4573188",
          "location_lon": "-100.623978"
        },
        "interfaces": [
          {
            "interfaceid": "150",
            "hostid": "10628",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.203.81",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10629",
        "host": "APASA-C4-TELEFONIA-BUFFALO-WD-MY-CLOUD-EX2-ULTRA-NAS-GTO-SUB-APAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "46",
            "name": "TELEFONIA/NAS",
            "internal": "0",
            "flags": "0",
            "uuid": "d784be157c1947eeba80d151c15a6273"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "64",
            "name": "APASEO EL ALTO",
            "internal": "0",
            "flags": "0",
            "uuid": "149aa153e4624ac1b11d01264d26d89f"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Estatal Apaseo el Alto-Tarimoro s/n, Entronque La Luisiada, Apaseo el Alto, Gto.",
          "location_lat": "20.4573188",
          "location_lon": "-100.623978"
        },
        "interfaces": [
          {
            "interfaceid": "151",
            "hostid": "10629",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.203.108",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10630",
        "host": "APASA-C4-TELEFONIA-ISSABEL-ISS-UCR-ENTRY-PBX-ISB-HA-GTO-SUB-APAL-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "47",
            "name": "TELEFONIA/PBX/FLOTANTE",
            "internal": "0",
            "flags": "0",
            "uuid": "0c74af60060f4249b4da486409ca44ab"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "64",
            "name": "APASEO EL ALTO",
            "internal": "0",
            "flags": "0",
            "uuid": "149aa153e4624ac1b11d01264d26d89f"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Estatal Apaseo el Alto-Tarimoro s/n, Entronque La Luisiada, Apaseo el Alto, Gto.",
          "location_lat": "20.4573188",
          "location_lon": "-100.623978"
        },
        "interfaces": [
          {
            "interfaceid": "152",
            "hostid": "10630",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.203.105",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10633",
        "host": "APASG-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18361-GTO-SUB-APGR-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "66",
            "name": "APASEO EL GRANDE",
            "internal": "0",
            "flags": "0",
            "uuid": "7f4ba12333f24b0a9da7b79c503581dd"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Esq. Narciso Mendoza con Melchor Ocampo, sin numero, Apaseo el Grande, Gto.",
          "location_lat": "20.5488393",
          "location_lon": "-100.688098"
        },
        "interfaces": [
          {
            "interfaceid": "155",
            "hostid": "10633",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.104.15",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10634",
        "host": "APASG-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18362-GTO-SUB-APGR-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "66",
            "name": "APASEO EL GRANDE",
            "internal": "0",
            "flags": "0",
            "uuid": "7f4ba12333f24b0a9da7b79c503581dd"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Esq. Narciso Mendoza con Melchor Ocampo, sin numero, Apaseo el Grande, Gto.",
          "location_lat": "20.5488393",
          "location_lon": "-100.688098"
        },
        "interfaces": [
          {
            "interfaceid": "156",
            "hostid": "10634",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.104.11",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10635",
        "host": "APASG-C4-TELEFONIA-BUFFALO-WD-MY-CLOUD-EX2-ULTRA-NAS-GTO-SUB-APGR-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "46",
            "name": "TELEFONIA/NAS",
            "internal": "0",
            "flags": "0",
            "uuid": "d784be157c1947eeba80d151c15a6273"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "66",
            "name": "APASEO EL GRANDE",
            "internal": "0",
            "flags": "0",
            "uuid": "7f4ba12333f24b0a9da7b79c503581dd"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Esq. Narciso Mendoza con Melchor Ocampo, sin numero, Apaseo el Grande, Gto.",
          "location_lat": "20.5488393",
          "location_lon": "-100.688098"
        },
        "interfaces": [
          {
            "interfaceid": "157",
            "hostid": "10635",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.204.108",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10636",
        "host": "APASG-C4-TELEFONIA-MEDIATRIX-3301-001-MEDIA-GATEWAY-MEDIATRIX01-GTO-SUB-APGR-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "66",
            "name": "APASEO EL GRANDE",
            "internal": "0",
            "flags": "0",
            "uuid": "7f4ba12333f24b0a9da7b79c503581dd"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Esq. Narciso Mendoza con Melchor Ocampo, sin numero, Apaseo el Grande, Gto.",
          "location_lat": "20.5488393",
          "location_lon": "-100.688098"
        },
        "interfaces": [
          {
            "interfaceid": "158",
            "hostid": "10636",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.4.11",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10637",
        "host": "APASG-C4-TELEFONIA-MEDIATRIX-3301-001-MEDIA-GATEWAY-MEDIATRIX02-GTO-SUB-APGR-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "66",
            "name": "APASEO EL GRANDE",
            "internal": "0",
            "flags": "0",
            "uuid": "7f4ba12333f24b0a9da7b79c503581dd"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Esq. Narciso Mendoza con Melchor Ocampo, sin numero, Apaseo el Grande, Gto.",
          "location_lat": "20.5488393",
          "location_lon": "-100.688098"
        },
        "interfaces": [
          {
            "interfaceid": "159",
            "hostid": "10637",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.4.12",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10638",
        "host": "APASG-C4-TELEFONIA-ISSABEL-ISS-UCR-ENTRY-PBX-ISB-HA-GTO-SUB-APGR-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "47",
            "name": "TELEFONIA/PBX/FLOTANTE",
            "internal": "0",
            "flags": "0",
            "uuid": "0c74af60060f4249b4da486409ca44ab"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "66",
            "name": "APASEO EL GRANDE",
            "internal": "0",
            "flags": "0",
            "uuid": "7f4ba12333f24b0a9da7b79c503581dd"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Esq. Narciso Mendoza con Melchor Ocampo, sin numero, Apaseo el Grande, Gto.",
          "location_lat": "20.5488393",
          "location_lon": "-100.688098"
        },
        "interfaces": [
          {
            "interfaceid": "160",
            "hostid": "10638",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.204.105",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10639",
        "host": "CELA-C4-TELEFONIA-KHOMP- KMG-200-MS-MEDIA-GATEWAY-KHOMP01-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "161",
            "hostid": "10639",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.101",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          },
          {
            "interfaceid": "9510",
            "hostid": "10639",
            "main": "1",
            "type": "2",
            "useip": "1",
            "ip": "172.18.206.101",
            "dns": "",
            "port": "161",
            "available": "1",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": {
              "version": "2",
              "bulk": "1",
              "community": "{$SNMP_COMMUNITY}"
            }
          }
        ]
      },
      {
        "hostid": "10640",
        "host": "CELA-C4-TELEFONIA-KHOMP- KMG-200-MS-MEDIA-GATEWAY-KHOMP02-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "162",
            "hostid": "10640",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.102",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          },
          {
            "interfaceid": "9511",
            "hostid": "10640",
            "main": "1",
            "type": "2",
            "useip": "1",
            "ip": "172.18.206.102",
            "dns": "",
            "port": "161",
            "available": "1",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": {
              "version": "2",
              "bulk": "1",
              "community": "{$SNMP_COMMUNITY}"
            }
          }
        ]
      },
      {
        "hostid": "10641",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18100-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "163",
            "hostid": "10641",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.80",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10642",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18101-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "164",
            "hostid": "10642",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.81",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10643",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18102-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "165",
            "hostid": "10643",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.82",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10644",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18103-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "166",
            "hostid": "10644",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.83",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10645",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18104-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "167",
            "hostid": "10645",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.84",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10646",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18105-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "168",
            "hostid": "10646",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.85",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10647",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18106-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "169",
            "hostid": "10647",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.86",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10648",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18107-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "170",
            "hostid": "10648",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.87",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10649",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18108-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "171",
            "hostid": "10649",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.88",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10650",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18109-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "172",
            "hostid": "10650",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.89",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10651",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18110-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "173",
            "hostid": "10651",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.90",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10652",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18111-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "174",
            "hostid": "10652",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.91",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10653",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18112-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "175",
            "hostid": "10653",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.92",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10654",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18113-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "176",
            "hostid": "10654",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.93",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10655",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18114-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "177",
            "hostid": "10655",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.94",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10656",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18115-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "178",
            "hostid": "10656",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.98",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10657",
        "host": "CELA-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18116-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "179",
            "hostid": "10657",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.99",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10658",
        "host": "CELA-C4-TELEFONIA-WD-MY-CLOUD-EX2-ULTRA-NAS-NAS-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "46",
            "name": "TELEFONIA/NAS",
            "internal": "0",
            "flags": "0",
            "uuid": "d784be157c1947eeba80d151c15a6273"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "180",
            "hostid": "10658",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.108",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10659",
        "host": "CELA-C4-TELEFONIA-ELASTIX-NLX4000-PBX-ISB-HA-GTO-SUB-CELA-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "47",
            "name": "TELEFONIA/PBX/FLOTANTE",
            "internal": "0",
            "flags": "0",
            "uuid": "0c74af60060f4249b4da486409ca44ab"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "68",
            "name": "CELAYA",
            "internal": "0",
            "flags": "0",
            "uuid": "189f8ea60bbf491b938dcb76c8c18478"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Carretera Celaya-Salvatierra Km. 4.5, en la comunidad de los Mancera, Celaya, Gto.",
          "location_lat": "20.4812",
          "location_lon": "-100.801425"
        },
        "interfaces": [
          {
            "interfaceid": "181",
            "hostid": "10659",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.206.105",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10660",
        "host": "MANU-C4-TELEFONIA-MEDIATRIX-3301-001-MEDIA-GATEWAY-MEDIATRIX01-GTO-SUB-MADO-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "69",
            "name": "MANUEL DOBLADO",
            "internal": "0",
            "flags": "0",
            "uuid": "e17bf8d820ec4332ad19571061c55708"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Mina y Corona S/N, zona centro, Manuel Doblado, Gto.",
          "location_lat": "20.7277115",
          "location_lon": "-101.952619"
        },
        "interfaces": [
          {
            "interfaceid": "182",
            "hostid": "10660",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.7.11",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10661",
        "host": "MANU-C4-TELEFONIA-MEDIATRIX-3301-001-MEDIA-GATEWAY-MEDIATRIX02-GTO-SUB-MADO-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "69",
            "name": "MANUEL DOBLADO",
            "internal": "0",
            "flags": "0",
            "uuid": "e17bf8d820ec4332ad19571061c55708"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Mina y Corona S/N, zona centro, Manuel Doblado, Gto.",
          "location_lat": "20.7277115",
          "location_lon": "-101.952619"
        },
        "interfaces": [
          {
            "interfaceid": "183",
            "hostid": "10661",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.7.12",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10662",
        "host": "MANU-C4-TELEFONIA-CISCO-SPA-525G2-TELEFONO_VOIP-EXT-18381-GTO-SUB-MADO-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "69",
            "name": "MANUEL DOBLADO",
            "internal": "0",
            "flags": "0",
            "uuid": "e17bf8d820ec4332ad19571061c55708"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Mina y Corona S/N, zona centro, Manuel Doblado, Gto.",
          "location_lat": "20.7277115",
          "location_lon": "-101.952619"
        },
        "interfaces": [
          {
            "interfaceid": "184",
            "hostid": "10662",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.207.80",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10663",
        "host": "MANU-C4-TELEFONIA-BUFFALO-LS520DN0402-NAS-NAS-GTO-SUB-MADO-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "46",
            "name": "TELEFONIA/NAS",
            "internal": "0",
            "flags": "0",
            "uuid": "d784be157c1947eeba80d151c15a6273"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "69",
            "name": "MANUEL DOBLADO",
            "internal": "0",
            "flags": "0",
            "uuid": "e17bf8d820ec4332ad19571061c55708"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Mina y Corona S/N, zona centro, Manuel Doblado, Gto.",
          "location_lat": "20.7277115",
          "location_lon": "-101.952619"
        },
        "interfaces": [
          {
            "interfaceid": "185",
            "hostid": "10663",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.207.108",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10664",
        "host": "MANU-C4-TELEFONIA-ISSABEL-ISS-UCR-ENTRY-PBX-ISB-HA-GTO-SUB-MADO-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "47",
            "name": "TELEFONIA/PBX/FLOTANTE",
            "internal": "0",
            "flags": "0",
            "uuid": "0c74af60060f4249b4da486409ca44ab"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "69",
            "name": "MANUEL DOBLADO",
            "internal": "0",
            "flags": "0",
            "uuid": "e17bf8d820ec4332ad19571061c55708"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Mina y Corona S/N, zona centro, Manuel Doblado, Gto.",
          "location_lat": "20.7277115",
          "location_lon": "-101.952619"
        },
        "interfaces": [
          {
            "interfaceid": "186",
            "hostid": "10664",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.207.105",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10665",
        "host": "COMO-C4-TELEFONIA-SYNWAY-1004B-4O-MEDIA-GATEWAY-SYNWAY01-GTO-SUBV-COMO-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "70",
            "name": "COMONFORT",
            "internal": "0",
            "flags": "0",
            "uuid": "7af537cb2ed541709787c32ff66b9ef5"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Mariano Arista #1, Zona Centro Comonfort, Gto.",
          "location_lat": "20.7196893",
          "location_lon": "-100.764629"
        },
        "interfaces": [
          {
            "interfaceid": "187",
            "hostid": "10665",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.108.20",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10666",
        "host": "COMO-C4-TELEFONIA-GRANDSTREAM-GXP1625-TELEFONO_VOIP-EXT-18391-GTO-SUBV-COMO-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "70",
            "name": "COMONFORT",
            "internal": "0",
            "flags": "0",
            "uuid": "7af537cb2ed541709787c32ff66b9ef5"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Mariano Arista #1, Zona Centro Comonfort, Gto.",
          "location_lat": "20.7196893",
          "location_lon": "-100.764629"
        },
        "interfaces": [
          {
            "interfaceid": "188",
            "hostid": "10666",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.108.23",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10667",
        "host": "COMO-C4-TELEFONIA-GRANDSTREAM-GXP1625-TELEFONO_VOIP-EXT-18392-GTO-SUBV-COMO-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "70",
            "name": "COMONFORT",
            "internal": "0",
            "flags": "0",
            "uuid": "7af537cb2ed541709787c32ff66b9ef5"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Mariano Arista #1, Zona Centro Comonfort, Gto.",
          "location_lat": "20.7196893",
          "location_lon": "-100.764629"
        },
        "interfaces": [
          {
            "interfaceid": "189",
            "hostid": "10667",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.108.25",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10668",
        "host": "COMO-C4-TELEFONIA-GRANDSTREAM-GXP1625-TELEFONO_VOIP-EXT-18393-GTO-SUBV-COMO-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "48",
            "name": "TELEFONIA/TELVOIP",
            "internal": "0",
            "flags": "0",
            "uuid": "61319696be954ef8bf379ea4fa035455"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "70",
            "name": "COMONFORT",
            "internal": "0",
            "flags": "0",
            "uuid": "7af537cb2ed541709787c32ff66b9ef5"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Mariano Arista #1, Zona Centro Comonfort, Gto.",
          "location_lat": "20.7196893",
          "location_lon": "-100.764629"
        },
        "interfaces": [
          {
            "interfaceid": "190",
            "hostid": "10668",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "10.16.108.24",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
      {
        "hostid": "10669",
        "host": "CORO-C4-TELEFONIA-SYNWAY-1004B-4O-MEDIA-GATEWAY-SYNWAY01-GTO-SUBV-CORO-001",
        "maintenance_status": "0",
        "groups": [
          {
            "groupid": "45",
            "name": "TELEFONIA/MEDIAGATEWAY",
            "internal": "0",
            "flags": "0",
            "uuid": "3c59600bdbb344bfb7f9d9c4c6e2addf"
          },
          {
            "groupid": "58",
            "name": "APLICATIVOS",
            "internal": "0",
            "flags": "0",
            "uuid": "df6644d22e504b2cae117af8942f6aaa"
          },
          {
            "groupid": "71",
            "name": "CORONEO",
            "internal": "0",
            "flags": "0",
            "uuid": "e7b47ccc5d0d4774b969890d065f3d8d"
          }
        ],
        "tags": [],
        "inventory": {
          "location": "Ignacio Lozada #423, Zona Centro, 38590, Coroneo, Gto.",
          "location_lat": "20.1984748",
          "location_lon": "-100.3703231"
        },
        "interfaces": [
          {
            "interfaceid": "191",
            "hostid": "10669",
            "main": "1",
            "type": "1",
            "useip": "1",
            "ip": "172.18.9.2",
            "dns": "",
            "port": "10051",
            "available": "0",
            "error": "",
            "errors_from": "0",
            "disable_until": "0",
            "details": []
          }
        ]
      },
]

export default hosts